import { LayoutTemplateViewContainer } from './LayoutTemplateViewContainer';
import { useViewContainer } from './useViewContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const BasicViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();
  if (!ViewComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(LayoutTemplateViewContainer, Object.assign({
    StepViewComponent: ViewComponent
  }, viewContainerProps));
};